"use client";

import { Box, Skeleton } from "@mui/material";

/**
 * Loading skeleton for ArticleContent
 * Matches the approximate structure of the article page
 */
export default function ArticleContentSkeleton() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "800px",
        margin: "0 auto",
        padding: "1rem",
        minHeight: "80vh",
      }}
    >
      {/* Image skeleton */}
      <Skeleton
        variant="rounded"
        width="100%"
        height={280}
        sx={{ borderRadius: "1.5rem", mb: 3 }}
      />

      {/* Title skeleton */}
      <Skeleton variant="text" width="90%" height={48} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="70%" height={48} sx={{ mb: 2 }} />

      {/* Meta info skeleton (date, category) */}
      <Box sx={{ display: "flex", gap: 2, mb: 4, width: "100%" }}>
        <Skeleton variant="text" width={100} height={24} />
        <Skeleton variant="text" width={80} height={24} />
      </Box>

      {/* Content paragraph skeletons */}
      <Box sx={{ width: "100%" }}>
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="95%" height={24} />
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="80%" height={24} sx={{ mb: 3 }} />

        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="90%" height={24} />
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="75%" height={24} sx={{ mb: 3 }} />

        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="85%" height={24} />
      </Box>
    </Box>
  );
}
